import { PermissionModel } from "./permission";
import { RoleEnum } from "@vini-wine/core-enums";
import { RoleDto } from "@vini-wine/core-dtos";

export interface RoleModel {
  // transform
  id: RoleEnum;

  // available includes
  permissions?: PermissionModel[];
}

export const createRoleDtoFromAdminRoleModel = (role: RoleModel): RoleDto => {
  return {
    id: role.id,
    permissions: role.permissions,
  };
};
